<template>
	<div>
		<v-dialog v-model="dialog_date_selection" no-click-animation persistent full-height scrollable transition="dialog-bottom-transition">
	      <v-card>
	        <v-card-title class="title noshadow pb-0 pr-0 pt-0">
	        	Ledger {{statementType == 1 ? 'Statement' : 'Activity'}}
	      		<v-spacer></v-spacer>

	      		<v-btn flat icon @click="$parent.fn_closeDialog"><v-icon>close</v-icon></v-btn>
        		<!-- <v-subheader full-width>
        			Ledger Statement
        			<v-spacer></v-spacer>
        			<v-btn flat icon @click="$parent.fn_closeDialog"><v-icon>close</v-icon></v-btn>
        		</v-subheader> -->
        	</v-card-title>

	        <!-- <v-divider></v-divider> -->

	        <v-card-text dialog-card-content>

	        	<v-list nopadding>
	        		<v-list-tile>
			            <v-list-tile-content>
			              	<v-list-tile-title light-opacity-color>Custom</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>
					        <!-- <v-switch style="flex:none" class="hide-margins" hide-details v-model="isCustomeDate" @change="fn_toggleCustomDate"></v-switch> -->
					        <v-checkbox class="right-align-checkbox" v-model="isCustomeDate" @change="fn_toggleCustomDate"></v-checkbox>
			            </v-list-tile-action>
		        	</v-list-tile>
	        	</v-list>

	        	<v-list nopadding v-if="!isCustomeDate">

		        	<v-list-tile @click="range=7">
			            <v-list-tile-content>
			              <v-list-tile-title>Last 7 Days</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>
					        <v-icon v-if="range==7">radio_button_checked</v-icon>
					        <v-icon v-else>radio_button_unchecked</v-icon>
			            </v-list-tile-action>
		        	</v-list-tile>

		        	<v-list-tile @click="range=30">
			            <v-list-tile-content>
			              <v-list-tile-title>Last 30 Days</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>
					        <v-icon v-if="range==30">radio_button_checked</v-icon>
					        <v-icon v-else>radio_button_unchecked</v-icon>
			            </v-list-tile-action>
		        	</v-list-tile>

		        	<v-list-tile @click="range=0">
			            <v-list-tile-content>
			              <v-list-tile-title>All Time</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>
					        <v-icon v-if="range==0">radio_button_checked</v-icon>
					        <v-icon v-else>radio_button_unchecked</v-icon>
			            </v-list-tile-action>
		        	</v-list-tile>

		        </v-list>

	            <v-layout wrap pt-2 v-else>

	              	<v-form data-vv-scope="fields" full-width>

			        	<v-flex xs12 sm12 md12 form-item @click="openDatePicker('start', startDate)">
			               	<v-text-field  
			               		readonly 
			               		:value="fn_getStartDate()" 
			               		label="Start Date" 
			               		placeholder=" " 
			               		append-icon="arrow_drop_down"
			               		v-validate="'required'" 
			               		name="startDate"
			               		data-vv-name="startDate" 
			               		:error-messages="errors.collect('fields.startDate')"
			               		required>
			               	</v-text-field>

			            </v-flex>

			            <v-flex xs12 sm12 md12 form-item @click="openDatePicker('end', endDate)">
			               	<v-text-field  
			               		readonly 
			               		:value="fn_getEndDate()"
			               		label="End Date" 
			               		placeholder=" " 
			               		append-icon="arrow_drop_down"
			               		v-validate="'required'" 
			               		name="endDate"
			               		data-vv-name="endDate" 
			               		:error-messages="errors.collect('fields.endDate')"
			               		required>
			               	</v-text-field>

			            </v-flex>
	              	</v-form>

	            </v-layout>

	        </v-card-text>

	        <v-divider></v-divider>

	        <v-card-actions>
	          <!-- <v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click="closeDialog">close</v-btn>
	          <v-btn color="blue darken-1" flat @click="generateStatement">Done</v-btn> -->
	          	<v-layout row wrap>
	          		<v-flex xs4 sm4 md4 center-align @click="generateStatement('sharewhatsapp', range)">
	          			<div right-border>
							<div style="height:26px"><img src="../../../../../assets/icon_whatsapp.svg" alt="whatapp_icon"></img></div>
					    	<div class="font-weight-bold">Send</div>
						</div>
	          		</v-flex>
	          		<v-flex xs4 sm4 md4 center-align @click="generateStatement('share', range)">
	          			<div right-border>
							<div><v-icon>share</v-icon></div>
					    	<div class="font-weight-bold">Share</div>
						</div>	
	          		</v-flex>
	          		<v-flex xs4 sm4 md4 center-align @click="generateStatement('download', range)">
	          			<div>	
							<div><v-icon>vertical_align_bottom</v-icon></div>
					    	<div class="font-weight-bold">Download</div>
						</div>	
	          		</v-flex>
	          	</v-layout>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
export default{
	props:['closeDialog','openDatePicker', 'startDate', 'endDate', 'generateStatement', 'statementType'],
	data(){	
		return{
			dialog_date_selection: false,
			isCustomeDate:false,
			range:0
		}
	},
	methods:{
		openDialogWeb: function () {
			this.dialog_date_selection = true;
		},
		closeDialogWeb: function () {
			this.dialog_date_selection = false;
		},
		fn_getStartDate: function(){
			return this.$moment(this.startDate).format('DD-MMM-YYYY');
		},
		fn_getEndDate: function(){
			return this.$moment(this.endDate).format('DD-MMM-YYYY');
		},
		fn_toggleCustomDate: function(val){
			if(val){
				this.range = null;
			}
			else{
				this.range = 0;
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/ledgers/dialogs/dialog_statement.vue